import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import { CasesState } from '../../states/cases.state';
import { RemoveInvolvedEmployeeCommand } from './remove-involved-employee.command';

/**
 * Remove involved employee use case.
 * Removes a single employee from the involved employees list for a case.
 */
@Injectable({ providedIn: 'root' })
export class RemoveInvolvedEmployeeUseCase {
  private readonly _repository = inject(CasesRepository);
  private readonly _state = inject(CasesState);

  /**
   * Executes the remove involved employee use case.
   * @param command - The command containing case ID and user ID to remove
   * @returns Observable void
   */
  public execute(command: RemoveInvolvedEmployeeCommand): Observable<void> {
    this._state.setSavingCases(true);
    this._state.setErrorCases(null);

    return this._repository.removeInvolvedEmployee(command.caseId, command.userId).pipe(
      tap(() => {
        this._state.setSavingCases(false);
      }),
      catchError((error) => {
        this._state.setErrorCases(error.message || 'Failed to remove involved employee');
        this._state.setSavingCases(false);
        return throwError(() => error);
      })
    );
  }
}
